import { useEffect, useReducer } from 'react';

function debounceReducer<T>(_state: T, nextValue: T): T {
  return nextValue;
}

export function useDebounce<T>(value: T, delay = 300): T {
  const [debouncedValue, dispatch] = useReducer(debounceReducer<T>, value);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      dispatch(value);
    }, delay);

    return () => window.clearTimeout(timeoutId);
  }, [delay, value]);

  return debouncedValue;
}
